import React from "react";

const CurrentCourseSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto rounded-xl dark:bg-gray-800 dark:border-gray-700 px-3 pt-10 pb-6 mt-6 border-tborder-black/10 lg:mt-10">
      {/* Top Section */}
      <div className="flex flex-col-reverse lg:flex-row justify-start items-start mb-5 gap-2 lg:gap-10">
        <div className="w-full lg:w-72">
          {/* Progress Bar Skeleton */}
          <div className="w-full bg-gray-200 rounded-full dark:bg-gray-700">
            <div className="bg-gray-300 h-4 rounded-full"></div>
          </div>
          <h3 className="text-gray-300 text-sm font-bold mt-2">Loading...</h3>
        </div>

        {/* Breadcrumb Section */}
        <div className="flex items-center justify-center">
          <p className="font-bold text-lg text-gray-300">Loading...</p>
          <svg className="w-5 h-5 text-gray-300 mx-2" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M12.293 9l-4.293 4.293 1.414 1.414 6-6a1 1 0 00.293-.707V8.207a1 1 0 00-.293-.707l-6-6-1.414 1.414L12.293 9z" clipRule="evenodd" />
          </svg>
          <p className="font-bold text-gray-300">Loading...</p>
        </div>
      </div>

      {/* Tabs Section */}
      <div className="flex flex-col lg:flex-row">
        {/* Tabs Header Skeleton */}
        <div className="w-full lg:w-72 mb-2 space-y-3">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="flex items-center justify-start gap-2">
              <div className="bg-gray-300 rounded-full h-6 w-6"></div>
              <div className="bg-gray-300 h-4 w-3/4 rounded"></div>
            </div>
          ))}
        </div>

        {/* Tabs Body Skeleton */}
        <div className="w-full max-w-4xl rounded-xl dark:bg-gray-800 dark:border-gray-700 mx-auto p-4">
          <div className="aspect-w-16 aspect-h-9 bg-gray-300 rounded-lg"></div>
          <h2 className="font-bold text-md lg:text-xl text-gray-300 mt-4">Loading...</h2>
          <div className="bg-gray-300 h-4 w-1/3 rounded mt-2"></div>
          <div className="space-y-2 mt-4">
            <div className="bg-gray-300 h-4 rounded"></div>
            <div className="bg-gray-300 h-4 rounded"></div>
            <div className="bg-gray-300 h-4 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentCourseSkeleton;
